

import { Component, Vue } from 'vue-property-decorator'

import DualRing from '@/shared/loaders/LoaderDualRing.component.vue'

@Component
export default class HandleLoaders extends Vue {
  public hideLoader (): void {
    this.$q.loading.hide()
  }
  public showLoader (spinner: any): void {
    this.$q.loading.show({
      spinner
    })
  }
  public showDualRingSpinner (): void {
    this.showLoader(DualRing)
  }
}
